
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/updates",
      function () {
        return require("private-next-pages/app/updates/index.js");
      }
    ]);
  